import { SeasonalPeriodicityView } from "../view/seasonal_periodicity_view";
import { SeasonalPeriodicityData } from "../model/seasonal_periodicity_series";
import $ from "jquery";

class SeasonalPeriodicityController {
	private view: SeasonalPeriodicityView;
	private container: JQuery<HTMLElement>;

	constructor(container: JQuery<HTMLElement>) {
		this.container = container;
		this.view = new SeasonalPeriodicityView(container);
	}

	/**
	 * 季節的周期性データを取得してグラフを描画
	 */
	render(keyword: string, combinationKeyword: string): JQuery.Promise<any> {
		const dfd = $.Deferred<any>();

		// ローディング表示
		this.view.showLoading();

		// エンドポイントURLを構築
		const url = "/additional_researches/seasonal_periodicity";
		const params: any = {
			keyword: keyword,
			combination_keyword: combinationKeyword,
		};

		// データを取得
		$.ajax({
			url: url,
			method: "GET",
			dataType: "json",
			data: params,
		})
			.done((data: SeasonalPeriodicityData) => {
				// グラフを描画（キーワード情報も渡す）
				this.view.render(data, keyword, combinationKeyword);
				dfd.resolve(data);
			})
			.fail((xhr: any) => {
				// エラー表示
				let errorMessage = "エラーが発生しました。";
				if (xhr.responseJSON && xhr.responseJSON.error) {
					errorMessage = xhr.responseJSON.error;
				} else if (xhr.status === 0) {
					errorMessage = "ネットワークエラーが発生しました。";
				} else if (xhr.status >= 500) {
					errorMessage = "サーバーエラーが発生しました。";
				}
				this.view.showError(errorMessage);
				dfd.reject(xhr);
			});

		return dfd.promise();
	}
}

export { SeasonalPeriodicityController };

